import React from "react";

import Select from "./Select";

export const COLORS = [
  "#feac00",
  "#00fe83",
  "#00cbfe",
  "#fe00e9",
  "#fe003c",
  "#39ae00",
  "#a100fe",
  "#fe4e00",
  "#afafaf",
  "#ffffff"
];

const SelectColor = (props) => (
  <Select
    type="color"
    values={COLORS}
    {...props}
  />
);

export default SelectColor;


// WEBPACK FOOTER //
// ./src/components/Popup/SelectColor.js